.dw-button {
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: var(--color-panel-tint);
  color: var(--color-text);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background var(--transition), color var(--transition), opacity var(--transition);
}
.dw-button:hover { background: var(--jade-100); }
.dw-button[data-disabled] { opacity: .5; cursor: not-allowed; }
.dw-button--primary { color: #fff; background: var(--color-accent); }
.dw-button--primary:hover { background: var(--color-accent-hover); }
.dw-button--ghost { background: transparent; }
.dw-button--ghost:hover { background: var(--color-panel-tint); }
.dw-button--danger { color: var(--color-danger); }
.dw-button--danger:hover { background: var(--color-danger-soft); }
.dw-button--small { height: 28px; }
.dw-button--icon { width: 32px; padding: 0; }
.dw-button--small.dw-button--icon { width: 28px; }

.dw-tabs__list {
  position: relative;
  height: 34px;
  display: flex;
  border-bottom: 1px solid var(--color-border);
}
.dw-tabs__tab {
  position: relative;
  min-width: 0;
  padding: 0 12px;
  border: 0;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 12px;
  cursor: pointer;
}
.dw-tabs__tab[data-selected] { color: var(--color-accent-text); font-weight: 550; }
.dw-tabs__indicator { position: absolute; bottom: -1px; height: 2px; background: var(--color-accent); transition: all var(--transition); }
.dw-tabs__panel { height: calc(100% - 34px); outline: none; }

.dw-dialog__backdrop { position: fixed; inset: 0; z-index: 50; background: rgb(0 0 0 / 45%); }
.dw-dialog__viewport { position: fixed; inset: 0; z-index: 51; display: grid; place-items: center; padding: 16px; }
.dw-dialog__popup { width: min(460px, 100%); display: flex; flex-direction: column; border: 1px solid var(--color-border); border-radius: var(--radius-lg); background: var(--color-panel); box-shadow: var(--shadow-md); overflow: hidden; }
.dw-dialog__popup--with-aside { display: grid; grid-template-columns: minmax(0, 1fr) minmax(280px, .95fr); align-items: stretch; }
.dw-dialog__primary { min-width: 0; min-height: 0; flex: 1; display: flex; flex-direction: column; }
.dw-dialog__aside { min-width: 0; min-height: 0; overflow: auto; border-left: 1px solid var(--color-border); background: var(--color-panel-subtle); }
.dw-dialog__header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding: 14px 16px 6px; }
.dw-dialog__title { font-size: 18px; font-weight: 600; }
.dw-dialog__description { margin-top: 5px; color: var(--color-text-muted); font-size: 13px; }
.dw-dialog__close, .dw-toast__close { width: 28px; height: 28px; display: grid; place-items: center; border: 0; border-radius: var(--radius-md); background: transparent; color: var(--color-text-muted); cursor: pointer; }
.dw-dialog__close:hover, .dw-toast__close:hover { color: var(--color-text); background: var(--color-panel-subtle); }
.dw-dialog__body { padding: 10px 16px 16px; }
.dw-dialog__actions { display: flex; justify-content: flex-end; gap: 8px; padding: 0 16px 16px; }
.dw-tooltip { padding: 5px 7px; border: 1px solid var(--color-border); border-radius: var(--radius-sm); background: var(--gray-900); color: #fff; box-shadow: var(--shadow-sm); font-size: 11px; }
.dw-toast__viewport { position: fixed; right: 12px; bottom: 12px; z-index: 70; width: min(360px, calc(100vw - 24px)); display: grid; gap: 8px; }
.dw-toast { display: flex; justify-content: space-between; gap: 12px; padding: 10px 12px; border: 1px solid var(--color-border); border-radius: var(--radius-md); background: var(--color-panel); box-shadow: var(--shadow-md); }
.dw-toast__title { font-size: 13px; font-weight: 600; }
.dw-toast__description { color: var(--color-text-muted); font-size: 12px; }
